import type { LucideIcon } from "lucide-react";

import { cn } from "@/lib/utils";

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

/* Empty state — guide §5: 48px slate icon, H3 title, body, primary action.
   Centered with generous vertical padding so it doesn't feel cramped inside
   tables or cards. */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 px-6 py-12 text-center",
        className,
      )}
    >
      {Icon && (
        <Icon
          size={48}
          strokeWidth={1.5}
          className="text-slate-400"
          aria-hidden="true"
        />
      )}
      <p className="text-lg font-semibold text-navy">{title}</p>
      {description && (
        <p className="max-w-md text-sm text-slate">{description}</p>
      )}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
